import { render, staticRenderFns } from "./ConnectModal.vue?vue&type=template&id=256c8b72&scoped=true&"
import script from "./ConnectModal.vue?vue&type=script&lang=js&"
export * from "./ConnectModal.vue?vue&type=script&lang=js&"
import style0 from "./ConnectModal.vue?vue&type=style&index=0&id=256c8b72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256c8b72",
  null
  
)

export default component.exports